import * as tslib_1 from "tslib";
import 'moment-timezone';
import { InjectionToken } from '@angular/core';
import { Interval } from '@models';
import * as moment from 'moment';
var TIME_FILTER_PROPERTIES = ['creationTime', 'createdOn', 'time', 'timestamp'];
var intervalToDate = function (interval) {
    var now = moment();
    switch (interval) {
        case Interval.Hour:
            return now.clone().subtract(60, 'minute').toDate();
        case Interval.Day:
            return now.clone().subtract(1, 'day').minute(0).toDate();
        case Interval.Week:
            return now.clone().subtract(7, 'day').minute(0).toDate();
        case Interval.Month:
            return now.clone().subtract(1, 'month').minute(0).toDate();
    }
};
var ɵ0 = intervalToDate;
export var FILTER_BUILDER = new InjectionToken('Odata-Filter-Builder');
var ODataFilterBuilder = /** @class */ (function () {
    function ODataFilterBuilder() {
    }
    ODataFilterBuilder.prototype.build = function (page, sort, searchFilters, filters, expand, select, mapper) {
        var _a;
        var _this = this;
        var queryOptions = {
            skip: page.pageIndex * page.pageSize,
            top: page.pageSize,
        };
        if (!!sort.direction) {
            var sortKey = this._getMappedKey(sort.field, mapper);
            queryOptions.orderBy = [sortKey + " " + sort.direction];
        }
        if (expand.length > 0) {
            queryOptions.expand = expand;
        }
        if (select.length > 0) {
            queryOptions.select = select;
        }
        var filter = {
            or: [],
            and: [],
        };
        if (searchFilters) {
            filter.or = searchFilters.map(function (searchFilter) {
                var property = {};
                var mappedValue = _this._getMappedKey(searchFilter.property, mapper);
                if (typeof mappedValue === 'string') {
                    property[mappedValue] = {};
                    var method = (searchFilter.method || 'Contains').toLowerCase();
                    property[mappedValue][method] = searchFilter.value;
                    return property;
                }
                throw new Error('Collection filtering not implemented');
            });
        }
        var timeFilters = filters
            .filter(function (f) { return TIME_FILTER_PROPERTIES.includes(f.property); })
            .map(function (f) { return (tslib_1.__assign({}, f, { value: intervalToDate(f.value) })); });
        var stdFilters = filters.filter(function (f) { return !TIME_FILTER_PROPERTIES.includes(f.property); });
        (_a = filter.and).push.apply(_a, this._getFilterDefinitions(timeFilters.concat(stdFilters), mapper));
        queryOptions.filter = filter;
        return queryOptions;
    };
    ODataFilterBuilder.prototype._getMappedKey = function (key, mapper) {
        if (typeof key === 'symbol') {
            return null;
        }
        var mappedValue = key;
        if (mapper == null) {
            return mappedValue;
        }
        var parts = mappedValue.split('.');
        var currentMapping = mapper;
        var collectionMap = {
            property: null,
            collectionPath: null,
        };
        var collectionPath = [];
        var isParentAnArray = false;
        for (var i = 0; i < parts.length; i += 1) {
            var part = parts[i];
            var currentMapper = (currentMapping[part] || {});
            var isCurrentPathAnArray = currentMapper.isCollection;
            var mapValue = currentMapper.property || currentMapping[part];
            if (isParentAnArray) {
                collectionMap.property = mapValue;
            }
            else if (mapValue instanceof Array) {
                currentMapping = mapValue[1];
                collectionPath.push(mapValue[0]);
            }
            else {
                collectionPath.push(mapValue);
            }
            isParentAnArray = isCurrentPathAnArray;
        }
        if (collectionMap.property != null) {
            collectionMap.collectionPath = collectionPath.join('/');
            return collectionMap;
        }
        return collectionPath.join('/');
    };
    ODataFilterBuilder.prototype._getFilterDefinitions = function (filterModel, mapper) {
        var _this = this;
        var filterDefinitions = [];
        filterModel.forEach(function (filter) {
            var filterValue = filter.value instanceof Array ? filter.value : [filter];
            filterDefinitions.push.apply(filterDefinitions, filterValue.map(function (subFilter) {
                return _this._generateFilterEntry(subFilter, filter.property, mapper);
            }));
        });
        return filterDefinitions;
    };
    ODataFilterBuilder.prototype._generateFilterEntry = function (filter, key, mapper) {
        var _a, _b, _c;
        var filterDefinition = {};
        var value = filter.type == null ?
            filter.value :
            {
                type: filter.type,
                value: filter.value,
            };
        var mappedKey = this._getMappedKey(key, mapper);
        if (mappedKey) {
            var propertyKey = this._getMappedKey(filter.property || key, mapper);
            if (typeof propertyKey === 'string') {
                filterDefinition[propertyKey] = (_a = {},
                    _a[(filter.method || 'eq').toLowerCase()] = value,
                    _a);
            }
            else if (propertyKey) {
                filterDefinition[propertyKey.collectionPath] = {
                    any: (_b = {},
                        _b[propertyKey.property] = (_c = {},
                            _c[(filter.method || 'eq').toLowerCase()] = value,
                            _c),
                        _b),
                };
            }
        }
        return filterDefinition;
    };
    return ODataFilterBuilder;
}());
export { ODataFilterBuilder };
export { ɵ0 };
